import { render } from "./accordion.vue?vue&type=template&id=1bd37386&ts=true"
import script from "./accordion.ts?vue&type=script&lang=ts&external"
export * from "./accordion.ts?vue&type=script&lang=ts&external"

import "./accordion.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__